import { Container } from './styles'
import emailIcon from '../../assets/email-icon.svg'
import { Form } from '../Form/Form'
import phoneIcon from '../../assets/phone-icon.svg'

export function Contact() {
  return (
    <Container id="contact">
      <div className="section-header">
        <p className="eyebrow">Contact</p>
        <h2>Let's build together</h2>
        <p className="muted">Ready to get started? Reach out for a discovery call or drop a note below.</p>
      </div>

      <div className="contact-grid">
        <div className="card quick-card">
          <div className="contact-item">
            <div className="icon-circle">
              <img src={emailIcon} alt="" />
            </div>
            <div>
              <p className="label">Email</p>
              <a href="mailto:sultanameher5@gmail.com" className="value">
                sultanameher5@gmail.com
              </a>
            </div>
          </div>
          <div className="contact-item">
            <div className="icon-circle">
              <img src={phoneIcon} alt="" />
            </div>
            <div>
              <p className="label">Phone</p>
              <a href="tel:+13399704709" className="value">
                +1 (339) 970-4709
              </a>
            </div>
          </div>
        </div>

        <div className="card form-card">
          <Form />
        </div>
      </div>
    </Container>
  )
}
